<template>
  <b-modal
    id="edit-saved-filter-modal"
    ref="edit-saved-filter-modal"
    title="EDIT SAVED FILTER"
    title-tag="h4"
    title-class="text-uppercase font-weight-bolder"
    size="xl"
    hide-footer
    centered
    @hidden="resetModal"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col md="3">
          <b-form-group
            label="Filter Name"
            label-for="edit-filter-name"
          >
            <b-form-input
              id="edit-filter-name"
              v-model="localFilter.name"
              placeholder="Filter Name"
              :state="nameState"
              required
            />
            <b-form-invalid-feedback :state="nameState">
              {{ nameFeedback }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col md="3">
          <b-form-group label="Status">
            <status-filter-modal
              v-model="localFilters.status"
              modal-id="status-filter-modal-edit-saved"
              :status-options="options.status"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Customer Name">
            <b-form-input
              v-model="localFilters.customer_name"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Origin Warehouse">
            <v-select
              v-model="localFilters.origin_warehouse"
              :options="options.warehouses"
              :reduce="val => val.id"
              label="name"
              placeholder="Select Warehouse"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Destination Warehouse">
            <v-select
              v-model="localFilters.destination_warehouse"
              :options="options.warehouses"
              multiple
              :reduce="val => val.id"
              label="name"
              placeholder="Select Warehouse"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="Origin City">
            <v-select
              v-model="localFilters.origin_city_id"
              :options="options.cities"
              :reduce="val => val.id"
              label="name"
              placeholder="Select Origin City"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Destination City">
            <v-select
              v-model="localFilters.destination_city_id"
              :options="options.cities"
              :reduce="val => val.id"
              label="name"
              placeholder="Select Destination City"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Customer Mobile Number">
            <b-form-input
              v-model="localFilters.customer_phone"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Weight">
            <b-form-input
              v-model="localFilters['orders.weight']"
              placeholder="0000 to 0000"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="Order Date">
            <advanced-date-filter
              :date-value="localFilters['orders.created_at']"
              @update="localFilters['orders.created_at'] = $event"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Merchant">
            <v-select
              v-model="localFilters.merchant_id"
              :options="options.merchants"
              multiple
              :reduce="val => val.id"
              label="name"
              placeholder="Select Merchant"
              @input="onMerchantChange"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Merchant Business">
            <v-select
              v-model="localFilters.merchant_business_id"
              :options="options.businesses"
              multiple
              :reduce="val => val.id"
              label="display_name"
              placeholder="Select Merchant Business"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Rider">
            <v-select
              v-model="localFilters.rider"
              :options="options.riders"
              :reduce="val => val.id"
              label="first_name"
              placeholder="Select Rider"
            >
              <template v-slot:option="option">
                {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="Status Changed Date">
            <advanced-date-filter
              :date-value="localFilters.status_date"
              @update="localFilters.status_date = $event"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="COD">
            <b-form-input
              v-model="localFilters['orders.cod']"
              placeholder="0000 to 0000"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Collected COD">
            <b-form-input
              v-model="localFilters['orders.collected_cod']"
              placeholder="0000 to 0000"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Temporary Warehouse">
            <v-select
              v-model="localFilters['orders.temporary_warehouse_id']"
              :options="options.warehouses"
              :reduce="val => val.id"
              label="name"
              placeholder="Select Warehouse"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group label="Walking Customer">
            <v-select
              v-model="localFilters.walking_customer_id"
              :options="options.walkingCustomers"
              :reduce="val => val.id"
              label="name"
              placeholder="Select Walking Customer"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Order Flags">
            <v-select
              v-model="localFilters.order_flag"
              :options="options.flags"
              multiple
              :reduce="val => val.id"
              label="name"
              placeholder="Select Flags"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="General Search">
            <b-form-input
              v-model="localFilters.search"
              placeholder="Search"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Delivery Attempts">
            <b-form-input
              v-model="localFilters.delivery_attempts"
              placeholder="00 to 00"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="primary"
          class="mr-1"
          type="submit"
        >
          Submit
        </b-button>
        <b-button
          variant="outline-secondary"
          @click="resetFilters"
        >
          Clear
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BButton, BFormInvalidFeedback,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import StatusFilterModal from '@/components/Filter/StatusFilterModal.vue'

export default {
  name: 'EditSavedFilterModal',
  components: {
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
    AdvancedDateFilter,
    BFormInvalidFeedback,
    StatusFilterModal,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localFilter: {
        id: null,
        name: '',
      },
      localFilters: {
        status: [],
      },
      submitted: false,
    }
  },
  computed: {
    nameFeedback() {
      if (!this.localFilter.name || this.localFilter.name.trim().length === 0) {
        return 'Filter name is required'
      }
      if (this.localFilter.name.length > 50) {
        return 'Filter name must be 50 characters or less'
      }
      return ''
    },
    nameState() {
      if (this.localFilter.name && this.localFilter.name.length > 50) {
        return false
      }
      if (this.submitted) {
        return !!(this.localFilter.name && this.localFilter.name.trim().length > 0)
      }
      return null
    },
  },
  methods: {
    openModal(filter) {
      this.localFilter = { ...filter }
      this.localFilters = { ...filter.filters }

      // Convert comma-separated strings back to arrays
      const arrayFields = ['status', 'order_flag', 'destination_warehouse', 'merchant_id', 'merchant_business_id']
      arrayFields.forEach(field => {
        if (typeof this.localFilters[field] === 'string') {
          this.localFilters[field] = this.localFilters[field].split(',').filter(x => x)
          if (field !== 'status') {
            this.localFilters[field] = this.localFilters[field].map(Number)
          }
        } else if (!this.localFilters[field]) {
          this.localFilters[field] = []
        }
      })

      this.$bvModal.show('edit-saved-filter-modal')
      if (this.localFilters.merchant_id && this.localFilters.merchant_id.length > 0) {
        this.$emit('fetch-businesses', this.localFilters.merchant_id)
      }
    },
    onMerchantChange(val) {
      this.$emit('fetch-businesses', val)
    },
    resetModal() {
      this.localFilter = { id: null, name: '' }
      this.localFilters = { status: [] }
      this.submitted = false
    },
    resetFilters() {
      this.localFilters = {
        'orders.created_at': { startDate: null, endDate: null },
        status: [],
        customer_name: '',
        origin_warehouse: null,
        destination_warehouse: [],
        origin_city_id: null,
        destination_city_id: null,
        customer_phone: '',
        'orders.weight': '',
        merchant_id: [],
        merchant_business_id: [],
        rider: null,
        status_date: { startDate: null, endDate: null },
        'orders.cod': '',
        'orders.collected_cod': '',
        'orders.temporary_warehouse_id': null,
        walking_customer_id: null,
        order_flag: [],
        search: '',
        delivery_attempts: '',
      }
    },
    handleSubmit() {
      this.submitted = true
      if (this.nameState === false) {
        return
      }
      // Convert arrays back to comma-separated strings for saving
      const finalFilters = { ...this.localFilters }
      const arrayFields = ['status', 'order_flag', 'destination_warehouse', 'merchant_id', 'merchant_business_id']
      arrayFields.forEach(field => {
        if (Array.isArray(finalFilters[field])) {
          finalFilters[field] = finalFilters[field].length > 0 ? `${finalFilters[field].join(',')},` : ''
        }
      })

      this.$emit('update', {
        id: this.localFilter.id,
        name: this.localFilter.name,
        filters: finalFilters,
      })
      this.$bvModal.hide('edit-saved-filter-modal')
    },
  },
}
</script>

<style scoped>
::v-deep .modal-header {
  background-color: #f3f2f7;
}
</style>

<style lang="scss">
.vs__selected {
  position: relative !important;
  display: inline-flex !important;
  align-items: center;
  max-width: 180px !important;
  padding-right: 20px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.vs__selected > span {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: inline-block !important;
  max-width: 100% !important;
}
.vs__deselect {
  position: absolute !important;
  right: 4px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
</style>
